import React from 'react';

const Sanoatvatexnik = () => {
    return (
        <div>
            Sanoatvatexnik
        </div>
    );
};

export default Sanoatvatexnik;